import Component from '../core/Component'
import support from '../utils/BrowserSupport'
import enquire from 'enquire.js'
import {
    queries
} from '../core/config'

export const STATES = {
    ACTIVE: 'is-openned',
    HIDE: 'is-hidden'
}

export default class ContactSlider extends Component {

    current = 0
    currentTime = 0
    running = false

    loadingStarted = null

    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            toggles: [],
        }

        this.circleLoader = document.querySelector(".hybrid-slider__counter .animated-circle-timer")
        this.circleLoaderWrap = document.querySelector(".hybrid-slider__counter")
        this.circleTotalLength

        this.autoPlaySpeed = 9000
        if (this.element.dataset.speed) {
            this.autoPlaySpeed = parseInt(this.element.dataset.speed)
        }

        this.isDesktop = false
        this.onceOpenned = false
        this.enquireHandler = {
            match: () => {
                this.isDesktop = true
            },
            unmatch: () => {
                this.isDesktop = false
            }
        }

        this.startSliding = this.start.bind(this)
        this.pauseSliding = this.pause.bind(this)
    }

    prepare() {

        enquire.register(queries.largeUp, this.enquireHandler)
        window.addEventListener("resize", this.resizer);

        this.element.addEventListener('open', (e) => {
            this.open(e.detail)
        })

        if (this.isDesktop) {
            this.ref.toggles.forEach(toggle => toggle.addEventListener('click', ::this.handleToggleClick))
            this.ref.items.forEach((item, index) => this.close(index, true))
            this.circleTotalLength = this.circleLoader.getTotalLength()
            // open first
            this.open(0)
            // autoplay , autopause when scrolled in/out
            this.element.addEventListener('enteredView', this.startSliding)
            this.onceOpenned = true;
            this.element.addEventListener('leftView', this.pauseSliding)
        }

    }

    destroy() {
        enquire.unregister(queries.largeMax, this.enquireHandler)
    }

    handleToggleClick(event) {
        if (this.isDesktop) {
            event.preventDefault()

            const index = this.ref.toggles.indexOf(event.currentTarget)
            this.toggle(index)
            this.pause()
            this.element.removeEventListener('enteredView', this.startSliding)
            this.element.removeEventListener('leftView', this.pauseSliding)
            this.circleLoaderWrap.classList.add(STATES.HIDE)
        }
    }

    toggle(itemIndex) {
        this.open(itemIndex)
    }


    open(itemIndex) {
        this.current = itemIndex
        const item = this.ref.items[itemIndex]

        item.classList.add(STATES.ACTIVE)
        this.currentTime = 0

        this.ref.items.forEach((item, index) => {
            if (index !== itemIndex) {
                this.close(index)
            }
        })

        this.getElement().dispatchEvent(new CustomEvent('itemOpened', {
            detail: itemIndex
        }))
    }

    close(itemIndex, force = false) {
        if (force || this.ref.items[itemIndex].classList.contains(STATES.ACTIVE)) {
            this.ref.items[itemIndex].classList.remove(STATES.ACTIVE)
        }

    }

    next() {
        let itemToOpen = (this.current + 1)

        if (itemToOpen >= this.ref.items.length) {
            itemToOpen = 0
        }
        this.open(itemToOpen)
    }

    updateProgressBar(time) {

        if (this.loadingStarted === null) {
            this.loadingStarted = time
        }
        if (this.isDesktop && this.running) {
            this.currentTime += (time - this.loadingStarted)
            let barWidth = (this.currentTime / this.autoPlaySpeed)
            if (barWidth > 1.05) {
                this.next()
            }
            this.circleLoader.style.strokeDashoffset = this.circleTotalLength - (this.circleTotalLength * barWidth)
            this.loadingStarted = time
            window.requestAnimationFrame(this.updateProgressBar.bind(this))
        }
        if (!this.running) {
            this.loadingStarted = null
        }
    }

    start() {
        this.running = true
        if (this.isDesktop) {
            window.requestAnimationFrame(this.updateProgressBar.bind(this))
        }
    }

    pause() {
        this.running = false
    }

    resizer = () => {
        if (window.innerWidth >= 1024 && this.onceOpenned === false) {
          this.prepare()
        }
     }
}
